import { useMutation, useNotify } from 'ra-core';
import { useCallback } from 'react';

const useGetDepoCouriers = () => {
	const notify = useNotify();
	const [mutate, { loaded, data }] = useMutation();

	const getDepoCouriers = useCallback(
		(depo: string, params: any) => {
			mutate(
				{
					type: 'getDepoCouriers',
					payload: { params, depo },
				},
				{
					onFailure: (error) => {
						notify(
							`Hiba: Nem sikerült betölteni a futárokat: ${error}`,
							'warning'
						);
					},
				}
			);
		},
		[mutate, notify]
	);

	return {
		getDepoCouriers,
		loaded,
		couriers: data?.couriers || [],
		count: data?.count || 0,
	};
};

export default useGetDepoCouriers;
